import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { CerebroTextButton } from '../../shared/components';

interface BulkTeasersProps {
	teasers: string[] | null;
	pendingTeaserCount: number;
	isOpen: boolean;
	close: () => void;
	onSubmit: () => void;
}

export const SendBulkTeasersDialog: React.FC<BulkTeasersProps> = ({
	teasers: selectedTeasers,
	pendingTeaserCount,
	isOpen,
	close,
	onSubmit,
}) => {
	const title = !!selectedTeasers && selectedTeasers.length > 0 ? 'Send Selected Teasers?' : 'Send Pending Teasers?';
	const content =
		!!selectedTeasers && selectedTeasers.length > 0
			? `Are you sure you want to send ${selectedTeasers.length} teasers?`
			: `There are ${pendingTeaserCount} pending teasers. Click yes to send.`;

	return (
		<>
			<Dialog open={isOpen} onClose={close}>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{content}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<CerebroTextButton onClick={close}>No</CerebroTextButton>
					<CerebroTextButton onClick={onSubmit}>Yes</CerebroTextButton>
				</DialogActions>
			</Dialog>
		</>
	);
};
